export function keysOf(obj) {
    return Object.keys(obj);
}
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @param obj
 * @param keys
 */
export function pick(obj, keys) {
    return keys.reduce((newObj, key) => (Object.assign(Object.assign({}, newObj), { [key]: obj[key] })), {});
}
/**
 * The opposite of `pick`; this method creates an `object` composed of the own and inherited
 * enumerable property paths of object that are not omitted.
 *
 * @param obj
 * @param keys
 */
export function omit(obj, keys) {
    return keysOf(obj)
        .filter((key) => keys.indexOf(key) < 0)
        .reduce((newObj, key) => (Object.assign(Object.assign({}, newObj), { [key]: obj[key] })), {});
}
